import { Component, OnInit } from '@angular/core';

import { ProductService } from '@app/services/product.service';

import {
  faMagnifyingGlass,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  faMagnifyingGlass = faMagnifyingGlass;
  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleDoubleRight = faAngleDoubleRight;

  products: any;

  constructor(public productService: ProductService) {}

  ngOnInit(): void {
    this.productService.products$.subscribe((result) => {
      this.products = result;
    });
  }
}
